"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routeGuardReducer = exports.getInitialState = void 0;
const getInitialState = () => {
    return {
        isRouteGuardModalOpen: false,
        isRouterBlocked: false,
        listeners: [],
        nextLocation: null,
        routeAction: null
    };
};
exports.getInitialState = getInitialState;
const routeGuardReducer = (state, action) => {
    switch (action.type) {
        case 'CONTINUE_EDITING':
            return Object.assign(Object.assign({}, state), { isRouteGuardModalOpen: false, routeAction: null, nextLocation: null });
        case 'SET_LISTENERS':
            return Object.assign(Object.assign({}, state), { listeners: [...state.listeners, ...action.payload] });
        case 'BLOCK_ROUTE':
            return Object.assign(Object.assign({}, state), { isRouterBlocked: true });
        case 'UNBLOCK_ROUTE':
            return Object.assign(Object.assign({}, state), { isRouteGuardModalOpen: false, isRouterBlocked: false });
        case 'CLOSE_MODAL':
            return Object.assign(Object.assign({}, state), { isRouteGuardModalOpen: false });
        case 'SET_ROUTE_INFO':
            return Object.assign(Object.assign(Object.assign({}, state), action.payload), { isRouteGuardModalOpen: true });
        case 'RESET_STATE':
            return exports.getInitialState();
        default:
            return state;
    }
};
exports.routeGuardReducer = routeGuardReducer;
